<template>
    <search-summary-layout
        :search-disabled="searchDisabled"
        :search-request="searchRequest"
        :form-component="formComponent"
        tourists-label="tourist"
        show-dates
        show-tourists
    >
        <template v-slot:title>
            {{ locationLabel }}
        </template>
    </search-summary-layout>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import SearchSummaryLayout from '~src/components/parts/searchSummaryLayout.src'
    import VisaSearchForm from '~/components/visa/search/forms/VisaSearchForm.vue'

    @Component({
        components: {
            SearchSummaryLayout,
            VisaSearchForm,
        },
    })
    export class VisaSearchSummary extends Vue {
        @Prop({default: false, type: Boolean}) searchDisabled
        @Prop({required: true}) searchRequest

        get locationLabel() {
            return `${visaRuntimeStore.location.name}`
        }

        get formComponent() {
            return resolveComponent('VisaSearchForm')
        }
    }

    export default VisaSearchSummary
</script>
